import React, { useEffect, FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectSimilarInquiries } from "src/redux/inquiries/selectors";
import { getSimilarInquiriesAsync } from "src/redux/inquiries/actions";
import { Loader } from "src/components/Loader";
import { InquiryCard } from "src/components/InquiryCard";
import { inquiryItemTrns } from "./trns";
import { Sizes } from "src/@types/sizes";

interface Props {
  id: number;
}

export const SimilarInquiries: FC<Props> = ({ id }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { data, isLoading } = useAppSelector(selectSimilarInquiries);

  useEffect(() => {
    dispatch(getSimilarInquiriesAsync(id));
  }, [dispatch, id]);

  const inquiriesResult = data || [];

  if (isLoading) {
    return <Loader size={Sizes.L} />;
  }

  if (!inquiriesResult?.length) return null;

  return (
    <div className="flex flex-col gap-3 sm:gap-5">
      <h3>{t(inquiryItemTrns.similarInquiriesTitle)}</h3>

      <div className="flex flex-col gap-5">
        {inquiriesResult.map((inquiry) => (
          <InquiryCard key={inquiry.id} inquiry={inquiry} isReadOnly />
        ))}
      </div>
    </div>
  );
};
